import React from 'react';
import { useTranslation } from 'react-i18next';
import { FcGoogle } from 'react-icons/fc';
import { FiExternalLink, FiStar } from 'react-icons/fi';

const GOOGLE_PROFILE_URL = 'https://share.google/Du9q2Zr7UFHvNxLhr';

function TestimonialsBlock({ title = 'Stories From Krabi Travelers', subtitle = 'Real feedback from Google Reviews' }) {
    const { t } = useTranslation();
    const testimonials = t('testimonials', { returnObjects: true });
    const testimonialItems = Array.isArray(testimonials?.items) ? testimonials.items : [];
    const loopItems = [...testimonialItems, ...testimonialItems];

    return (
        <section className='mx-auto my-10 w-[94%] max-w-6xl' aria-labelledby='testimonials-heading'>
            <div className='rounded-[1.75rem] border border-slate-200 bg-white p-6 shadow-[0_18px_50px_rgba(15,23,42,0.08)] sm:p-8'>
                <div className='flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between'>
                    <div>
                        <h2 id='testimonials-heading' className='text-2xl font-black text-slate-950 sm:text-3xl'>
                            {title || testimonials?.title}
                        </h2>
                        <p className='mt-1 text-sm font-medium text-slate-500'>{subtitle || testimonials?.subtitle}</p>
                    </div>
                    <a
                        href={GOOGLE_PROFILE_URL}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='inline-flex items-center gap-2 self-start rounded-full border border-slate-200 bg-slate-50 px-4 py-2 text-sm font-semibold text-slate-700 transition hover:border-indigo-200 hover:bg-indigo-50 hover:text-[#1739bd]'
                    >
                        {testimonials?.viewProfile}
                        <FiExternalLink />
                    </a>
                </div>

                <div className='mt-6 overflow-hidden'>
                    <div className='flex w-max animate-[testimonials-marquee_38s_linear_infinite] gap-4 hover:[animation-play-state:paused]'>
                        {loopItems.map((item, index) => (
                            <article
                                key={`${item.name}-${item.when}-${index}`}
                                className='flex min-h-[235px] w-[86vw] max-w-sm flex-col rounded-2xl border border-slate-200 bg-gradient-to-br from-white to-slate-50 p-5 shadow-[0_8px_22px_rgba(15,23,42,0.06)]'
                            >
                                <div className='mb-3 flex items-center justify-between'>
                                    <div>
                                        <h3 className='text-sm font-bold text-slate-900'>{item.name}</h3>
                                        <div className='mt-1 inline-flex items-center gap-1 rounded-full bg-slate-100 px-2 py-1 text-[11px] font-semibold text-slate-600'>
                                            <FcGoogle className='text-base' />
                                            {testimonials?.badge}
                                        </div>
                                    </div>
                                    <div className='inline-flex items-center gap-1 text-amber-500'>
                                        {Array.from({ length: item.rating }).map((_, idx) => (
                                            <FiStar key={idx} className='fill-current' />
                                        ))}
                                    </div>
                                </div>

                                <p className='text-sm leading-7 text-slate-600'>"{item.quote}"</p>

                                <div className='mt-auto flex items-center justify-between pt-4'>
                                    <span className='text-xs font-semibold uppercase tracking-wide text-slate-400'>{item.when}</span>
                                    <a
                                        href={item.sourceUrl}
                                        target='_blank'
                                        rel='noopener noreferrer'
                                        className='text-xs font-bold text-[#1739bd] transition hover:opacity-80'
                                    >
                                        {testimonials?.source}
                                    </a>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </div>

            <style>{`
                @keyframes testimonials-marquee {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-50%); }
                }
            `}</style>
        </section>
    );
}

export default TestimonialsBlock;
